export const FETCH_AUTH_DETAILS = 'FETCH_AUTH_DETAILS'
export const SET_AUTH_DETAILS = 'SET_AUTH_DETAILS'
export const SAVE_CLIENT_ID = 'SAVE_CLIENT_ID'
export const SAVE_CLIENT_ID_IN_AUTH = 'SAVE_CLIENT_ID_IN_AUTH'
export const FETCH_CLIENT_PROFILE = 'FETCH_CLIENT_PROFILE';
export const SAVE_CLIENT_PROFILE = 'SAVE_CLIENT_PROFILE';
export const FETCH_CLIENT_SIDEBAR_MENUS = 'FETCH_CLIENT_SIDEBAR_MENUS';
export const SET_CLIENT_SIDEBAR_MENUS = 'SET_CLIENT_SIDEBAR_MENUS';
export const SET_CLIENT_USM_DETAILS = 'SET_CLIENT_USM_DETAILS';